
<div class="flexRow cursor upStoreTime" @click="change">
  <slot></slot>
  <div class="ml4" :class="getClass()" />
</div>
